export const cropListMapping = [
  {
    crop: 'ABETE BIANCO',
    key: 1557,
    label: 'Abete',
    note: null,
  },
  {
    crop: 'ABETE ROSSO',
    key: 1557,
    label: 'Abete',
    note: null,
  },
  {
    crop: 'ACERO SPP.',
    key: 1546,
    label: 'Acero',
    note: null,
  },
  {
    crop: 'ACTINIDIA',
    key: 1858,
    label: 'Actinidia (Kiwi)',
    note: null,
  },
  {
    crop: 'AGLIO',
    key: 1517,
    label: 'Aglio',
    note: null,
  },
  {
    crop: 'AGRUMI',
    key: 1708,
    label: 'Agrumi',
    note: 'riguarda',
  },
  {
    crop: 'ALBICOCCO',
    key: 1831,
    label: 'Albicocco',
    note: null,
  },
  {
    crop: 'ALTRA PICCOLA FRUTTA E BACCHE',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'ANEMONE',
    key: 1486,
    label: 'Anemone',
    note: null,
  },
  {
    crop: 'ANTURIO',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'AQUILEGIA',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'ARACHIDE',
    key: 1816,
    label: 'Arachide',
    note: null,
  },
  {
    crop: 'ARALIA',
    key: 1452,
    label: 'Aralia',
    note: null,
  },
  {
    crop: 'ARANCIO',
    key: 1561,
    label: 'Arancio',
    note: null,
  },
  {
    crop: 'ARANCIO AMARO',
    key: 1561,
    label: 'Arancio',
    note: null,
  },
  {
    crop: 'ASPARAGO',
    key: 1865,
    label: 'Asparago',
    note: null,
  },
  {
    crop: 'ASPARAGUS',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ASTER',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'AUCUBA',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'AVENA',
    key: 1776,
    label: 'Avena',
    note: null,
  },
  {
    crop: 'AZALEA',
    key: 1766,
    label: 'Azalea',
    note: null,
  },
  {
    crop: 'BARBA GENTILE',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'BARBABIETOLA DA FORAGGIO',
    key: 1581,
    label: 'Barbabietola - Rapa Rossa/Bietola Da Costa',
    note: 'riguarda',
  },
  {
    crop: 'BARBABIETOLA DA ZUCCHERO',
    key: 1581,
    label: 'Barbabietola - Rapa Rossa/Bietola Da Costa',
    note: 'riguarda',
  },
  {
    crop: 'BARBAREA',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'BASILICO',
    key: 1866,
    label: 'Basilico',
    note: null,
  },
  {
    crop: 'BEGONIA',
    key: 1779,
    label: 'Begonia',
    note: null,
  },
  {
    crop: 'BERBERIS',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'BERGAMOTTO',
    key: 1709,
    label: 'Bergamotto',
    note: null,
  },
  {
    crop: 'BETULLA',
    key: 1603,
    label: 'Betulla',
    note: null,
  },
  {
    crop: 'BIETOLA DA COSTA',
    key: 1465,
    label: 'Bietola (Compresa  La Cheltenham Beet',
    note: 'Barbabietola Rossa/Bietola Da Costa)',
  },
  {
    crop: 'BIETOLA DA FOGLIA',
    key: 1465,
    label: 'Bietola (Compresa  La Cheltenham Beet',
    note: 'Barbabietola Rossa/Bietola Da Costa)',
  },
  {
    crop: 'BIETOLA DA FOGLIA E DA COSTA',
    key: 1465,
    label: 'Bietola (Compresa  La Cheltenham Beet',
    note: 'Barbabietola Rossa/Bietola Da Costa)',
  },
  {
    crop: 'BIETOLA ROSSA (BIETOLA DA ORTO)',
    key: 1465,
    label: 'Bietola (Compresa  La Cheltenham Beet',
    note: 'Barbabietola Rossa/Bietola Da Costa)',
  },
  {
    crop: 'BOCCA DI LEONE',
    key: 1488,
    label: 'Bocca Di Leone',
    note: null,
  },
  {
    crop: 'BOSSO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'BOUVARDIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'BRASSICA RAPA VAR. NIPPONICA (MIZUMA)',
    key: 1783,
    label: 'Mizuna O Brassica Rapa',
    note: null,
  },
  {
    crop: 'BROMELIACEE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'BULBOSE DA FIORE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'CACO',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'CACTACEE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'CACTUS',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'CAMELIA',
    key: 1771,
    label: 'Camelia',
    note: null,
  },
  {
    crop: 'CANAPA',
    key: 1492,
    label: 'Canapa',
    note: null,
  },
  {
    crop: 'CARCIOFO',
    key: 1867,
    label: 'Carciofo',
    note: null,
  },
  {
    crop: 'CARDO',
    key: 1630,
    label: 'Cardo Mariano',
    note: 'riguarda',
  },
  {
    crop: 'CAROTA',
    key: 1467,
    label: 'Carota',
    note: null,
  },
  {
    crop: 'CASTAGNO',
    key: 1751,
    label: 'Castagno',
    note: null,
  },
  {
    crop: 'CASTAGNO (FORESTALE)',
    key: 1751,
    label: 'Castagno',
    note: null,
  },
  {
    crop: 'CAVOLFIORE',
    key: 1520,
    label: 'Cavolfiore',
    note: null,
  },
  {
    crop: 'CAVOLI',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLI A FOGLIA',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLI A INFIORESCENZA',
    key: 1520,
    label: 'Cavolfiore',
    note: null,
  },
  {
    crop: 'CAVOLI A TESTA',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLO BIANCO',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLO BROCCOLO',
    key: 1899,
    label: 'Cavolo Broccolo',
    note: null,
  },
  {
    crop: 'CAVOLO CAPPUCCIO',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLO CINESE',
    key: 1589,
    label: 'Cavolo Cinese',
    note: null,
  },
  {
    crop: 'CAVOLO DI BRUXELLES',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLO NERO',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLO RAPA',
    key: 1886,
    label: 'Cavolo Rapa',
    note: null,
  },
  {
    crop: 'CAVOLO RICCIO',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLO ROSSO',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CAVOLO VERZA',
    key: 1468,
    label: 'Cavolo',
    note: null,
  },
  {
    crop: 'CECE',
    key: 1785,
    label: 'Cece',
    note: null,
  },
  {
    crop: 'CEDRO',
    key: 1494,
    label: 'Cedro',
    note: null,
  },
  {
    crop: 'CEREALI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'CEREALI AUTUNNO-VERNINI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'CEREALI MINORI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'CERFOGLIO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'CETRIOLINI',
    key: 1869,
    label: 'Cetriolo',
    note: null,
  },
  {
    crop: 'CETRIOLO',
    key: 1869,
    label: 'Cetriolo',
    note: null,
  },
  {
    crop: 'CHINOTTO',
    key: 1674,
    label: 'Chinotto',
    note: null,
  },
  {
    crop: 'CICLAMINO',
    key: 1777,
    label: 'Ciclamino',
    note: null,
  },
  {
    crop: 'CICORIA',
    key: 1870,
    label: 'Cicoria',
    note: null,
  },
  {
    crop: 'CICORIA A FOGLIA ROSSA',
    key: 1870,
    label: 'Cicoria',
    note: null,
  },
  {
    crop: 'CICORIA DA RADICE',
    key: 1870,
    label: 'Cicoria',
    note: null,
  },
  {
    crop: 'CICORIA SELVATICA',
    key: 1870,
    label: 'Cicoria',
    note: null,
  },
  {
    crop: 'CILIEGIO DOLCE',
    key: 1832,
    label: 'Ciliegio',
    note: null,
  },
  {
    crop: 'CINERARIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'CIPOLLA',
    key: 1871,
    label: 'Cipolla Anche Di Tipo Lungo (Echalion)',
    note: null,
  },
  {
    crop: 'CIPOLLINE',
    key: 1576,
    label: "Cipolletta  Cipolla D'Inverno O Bunching Onion",
    note: 'riguarda',
  },
  {
    crop: 'CIPRESSO SPP.',
    key: 1560,
    label: 'Cipresso',
    note: null,
  },
  {
    crop: 'CLEMENTINE',
    key: 1563,
    label: 'Mandarancio (Clementino)',
    note: null,
  },
  {
    crop: 'COCOMERO',
    key: 1872,
    label: 'Cocomero',
    note: null,
  },
  {
    crop: 'COLTURA NON SPECIFICATA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'COLZA (FORAGGERE)',
    key: 1449,
    label: 'Colza',
    note: null,
  },
  {
    crop: 'COLZA (OLEAGINOSE)',
    key: 1449,
    label: 'Colza',
    note: null,
  },
  {
    crop: 'CONIFERE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'COTOGNO',
    key: 1825,
    label: 'Cotogno',
    note: null,
  },
  {
    crop: 'COTONE',
    key: 1826,
    label: 'Cotone',
    note: null,
  },
  {
    crop: 'CRESCIONE (O BECCALUNGA)',
    key: 1744,
    label: 'Crescione Dei Giardini O Crescione Inglese',
    note: null,
  },
  {
    crop: 'CRESCIONE ACQUATICO',
    key: 1744,
    label: 'Crescione Dei Giardini O Crescione Inglese',
    note: 'riguarda',
  },
  {
    crop: 'CRISANTEMO',
    key: 1505,
    label: 'Crisantemo',
    note: null,
  },
  {
    crop: 'CUCURBITACEE',
    key: 1880,
    label: 'Zucca',
    note: null,
  },
  {
    crop: 'CUCURBITACEE',
    key: 1881,
    label: 'Zucchino',
    note: null,
  },
  {
    crop: 'CUCURBITACEE CON BUCCIA COMMESTIBILE',
    key: 1881,
    label: 'Zucchino',
    note: null,
  },
  {
    crop: 'CUCURBITACEE CON BUCCIA NON COMMESTIBILE',
    key: 1880,
    label: 'Zucca',
    note: null,
  },
  {
    crop: 'DALIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'DELPHINIUM',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'DOLCETTA',
    key: 1542,
    label: 'Dolcetta (Gallinella',
    note: 'Soncino',
  },
  {
    crop: 'DORONICUM SPP.',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'DRAGONCELLO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'DRUPACEE',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'EDERA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ERBA CIPOLLINA',
    key: 1882,
    label: 'Erba Cipollina',
    note: null,
  },
  {
    crop: 'ERBA MEDICA',
    key: 1799,
    label: 'Erba Medica',
    note: null,
  },
  {
    crop: 'ERBE FRESCHE',
    key: 1764,
    label: 'Piante Aromatiche E Medicinali E Spezie',
    note: null,
  },
  {
    crop: 'ERICA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ERICACE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'EUCALIPTO',
    key: 1829,
    label: 'Eucalipto',
    note: null,
  },
  {
    crop: 'EVONIMO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FAGGIO',
    key: 1607,
    label: 'Faggio',
    note: null,
  },
  {
    crop: 'FAGIOLINO',
    key: 1522,
    label: 'Fagiolino',
    note: null,
  },
  {
    crop: 'FAGIOLO',
    key: 1523,
    label: 'Fagiolo',
    note: null,
  },
  {
    crop: 'FARRO',
    key: 1454,
    label: 'Farro',
    note: null,
  },
  {
    crop: 'FAVA',
    key: 1800,
    label: 'Fave',
    note: 'Favino  E Favette',
  },
  {
    crop: 'FAVINO',
    key: 1800,
    label: 'Fave',
    note: 'Favino  E Favette',
  },
  {
    crop: 'FICO',
    key: 1734,
    label: 'Fico',
    note: null,
  },
  {
    crop: 'FICUS',
    key: 1767,
    label: 'Ficus Benjamina',
    note: null,
  },
  {
    crop: 'FILODENDRO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FINOCCHIO',
    key: 1873,
    label: 'Finocchio',
    note: null,
  },
  {
    crop: 'FIORDALISO',
    key: 1638,
    label: 'Fiordaliso',
    note: null,
  },
  {
    crop: 'FLOREALI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FLOREALI BULBOSE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FLOREALI RIZOMATOSE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FLOREALI TUBEROSE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FOGLIE DI ALLORO (ERBE FRESCHE)',
    key: 1745,
    label: 'Alloro',
    note: null,
  },
  {
    crop: 'FOGLIE DI SEDANO (ERBE FRESCHE)',
    key: 1530,
    label: 'Sedano',
    note: null,
  },
  {
    crop: 'FOGLIE E GERMOGLI DI BRASSICACEE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FORAGGERE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FORESTALI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FRAGOLA',
    key: 1874,
    label: 'Fragola',
    note: null,
  },
  {
    crop: 'FRASSINO',
    key: 1896,
    label: 'Frassino',
    note: null,
  },
  {
    crop: 'FRESIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FRUMENTO',
    key: 1448,
    label: 'Grano (Frumento) Duro',
    note: null,
  },
  {
    crop: 'FRUMENTO',
    key: 1803,
    label: 'Grano (Frumento) Tenero',
    note: null,
  },
  {
    crop: 'FRUTTA VARIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FRUTTI DI PIANTE ARBUSTIVE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FRUTTIFERI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FRUTTIFERI A GUSCIO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FUCSIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'FUNGHI COLTIVATI',
    key: 1715,
    label: 'Funghi',
    note: null,
  },
  {
    crop: 'GAROFANO',
    key: 1506,
    label: 'Garofano',
    note: null,
  },
  {
    crop: 'GERANIO',
    key: 1778,
    label: 'Geranio',
    note: null,
  },
  {
    crop: 'GERBERA',
    key: 1459,
    label: 'Gerbera',
    note: null,
  },
  {
    crop: 'GIACINTO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'GIGLIO',
    key: 1642,
    label: 'Giaggiolo O Giglio  Bianco  Iris Fiorentina',
    note: null,
  },
  {
    crop: 'GINESTRINO',
    key: 1802,
    label: 'Ginestrino',
    note: null,
  },
  {
    crop: 'GIRASOLE',
    key: 1451,
    label: 'Girasole',
    note: null,
  },
  {
    crop: 'GLADIOLO',
    key: 1476,
    label: 'Gladiolo',
    note: null,
  },
  {
    crop: 'GRAMINACEE FORAGGERE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'GRANO SARACENO',
    key: 1805,
    label: 'Grano Saraceno',
    note: null,
  },
  {
    crop: 'IGNAME',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'INDIVIA',
    key: 1539,
    label: 'Indivia O Scarola',
    note: null,
  },
  {
    crop: 'INDIVIA RICCIA',
    key: 1539,
    label: 'Indivia O Scarola',
    note: null,
  },
  {
    crop: 'IPPOCASTANO',
    key: 1616,
    label: "Ippocastano O Castagno D'India",
    note: null,
  },
  {
    crop: 'IRIS',
    key: 1641,
    label: 'Giaggiolo (Iris) Pallida',
    note: null,
  },
  {
    crop: 'IRIS',
    key: 1642,
    label: 'Giaggiolo O Giglio  Bianco  Iris Fiorentina',
    note: null,
  },
  {
    crop: 'ISSOPO',
    key: 1646,
    label: 'Issopo',
    note: null,
  },
  {
    crop: 'KALANCHLOE',
    key: 1780,
    label: 'Kalanchoe',
    note: null,
  },
  {
    crop: 'KUMQUAT',
    key: 1577,
    label: 'Qumquat',
    note: null,
  },
  {
    crop: 'LAMPONE',
    key: 1735,
    label: 'Lampone',
    note: null,
  },
  {
    crop: 'LATIFOGLIE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'LATTUGA',
    key: 1524,
    label: 'Lattuga Lattughino',
    note: null,
  },
  {
    crop: 'LATTUGHE E SIMILI',
    key: 1524,
    label: 'Lattuga Lattughino',
    note: null,
  },
  {
    crop: 'LEGUMI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'LEGUMINOSE FORAGGERE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'LENTICCHIA',
    key: 1458,
    label: 'Lenticchie',
    note: null,
  },
  {
    crop: 'LILIUM',
    key: 1511,
    label: 'Lilium',
    note: null,
  },
  {
    crop: "LILLA'",
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'LIMETTA',
    key: 1710,
    label: 'Limette',
    note: null,
  },
  {
    crop: 'LIMONE',
    key: 1564,
    label: 'Limone',
    note: null,
  },
  {
    crop: 'LINO',
    key: 1491,
    label: 'Lino',
    note: null,
  },
  {
    crop: 'LUPINELLA',
    key: 1808,
    label: 'Lupinella',
    note: null,
  },
  {
    crop: 'LUPINO',
    key: 1810,
    label: 'Lupino',
    note: null,
  },
  {
    crop: 'LUPPOLO',
    key: 1501,
    label: 'Luppolo',
    note: null,
  },
  {
    crop: 'MAGGIORANA',
    key: 1893,
    label: 'Maggiorana',
    note: null,
  },
  {
    crop: 'MAHONIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'MAIS',
    key: 1447,
    label: 'Granturco (Mais)',
    note: null,
  },
  {
    crop: 'MAIS DOLCE',
    key: 1447,
    label: 'Granturco (Mais)',
    note: null,
  },
  {
    crop: 'MANDARANCIO',
    key: 1563,
    label: 'Mandarancio (Clementino)',
    note: null,
  },
  {
    crop: 'MANDARINO',
    key: 1562,
    label: 'Mandarino',
    note: null,
  },
  {
    crop: 'MANDORLO',
    key: 1752,
    label: 'Mandorlo',
    note: null,
  },
  {
    crop: 'MARGHERITA',
    key: 1513,
    label: 'Margherita',
    note: null,
  },
  {
    crop: 'MELANZANA',
    key: 1525,
    label: 'Melanzana',
    note: null,
  },
  {
    crop: 'MELISSA',
    key: 1890,
    label: 'Melissa',
    note: null,
  },
  {
    crop: 'MELO',
    key: 1481,
    label: 'Melo',
    note: null,
  },
  {
    crop: 'MELO SELVATICO',
    key: 1481,
    label: 'Melo',
    note: null,
  },
  {
    crop: 'MELOGRANO',
    key: 1691,
    label: 'Melograno',
    note: null,
  },
  {
    crop: 'MELONE',
    key: 1526,
    label: 'Melone',
    note: null,
  },
  {
    crop: 'MENTA',
    key: 1891,
    label: 'Menta',
    note: null,
  },
  {
    crop: 'MIGLIO',
    key: 1814,
    label: 'Miglio',
    note: null,
  },
  {
    crop: 'MIMOSA',
    key: 1478,
    label: 'Mimosa',
    note: null,
  },
  {
    crop: 'NARCISO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'NASHI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'NAVONE',
    key: 1510,
    label: 'Navoni Rutabaga',
    note: null,
  },
  {
    crop: 'NESPOLO',
    key: 1738,
    label: 'Nespolo',
    note: null,
  },
  {
    crop: 'NESPOLO DEL GIAPPONE',
    key: 1738,
    label: 'Nespolo',
    note: null,
  },
  {
    crop: 'NOCCIOLO',
    key: 1753,
    label: 'Nocciolo',
    note: null,
  },
  {
    crop: 'NOCE',
    key: 1754,
    label: 'Noce',
    note: null,
  },
  {
    crop: 'OKRA (GOMBO)',
    key: 1732,
    label: 'Okra O Ocra O Gombo',
    note: null,
  },
  {
    crop: 'OLEAGINOSE',
    key: 'nd',
    label: 'nd',
    note: 'guarda',
  },
  {
    crop: 'OLEANDRO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'OLI VE DA TAVOLA',
    key: 1702,
    label: 'Olivo',
    note: null,
    priority: 3,
  },
  {
    crop: 'OLIVE DA OLIO',
    key: 1702,
    label: 'Olivo',
    note: null,
    priority: 2,
  },
  {
    crop: 'OLIVO',
    key: 1702,
    label: 'Olivo',
    note: null,
  },
  {
    crop: 'OLMO SPP.',
    key: 1550,
    label: 'Olmo',
    note: null,
  },
  {
    crop: 'ONTANO',
    key: 1547,
    label: 'Ontano',
    note: null,
  },
  {
    crop: 'ORIGANO',
    key: 1892,
    label: 'Origano',
    note: null,
  },
  {
    crop: 'ORNAMENTALI',
    key: 1817,
    label: 'Piante Ornamentali',
    note: null,
  },
  {
    crop: 'ORTAGGI',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ORTAGGI A BULBO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ORTAGGI A FOGLIA E ERBE FRESCHE',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ORTAGGI A FRUTTO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ORTAGGI A RADICE E TUBERO',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'ORTAGGI A STELO',
    key: 'nd',
    label: 'nd',
    note: 'riguarda',
  },
  {
    crop: 'ORTENSIA',
    key: 1464,
    label: 'Ortensia',
    note: null,
  },
  {
    crop: 'ORZO',
    key: 1862,
    label: 'Orzo',
    note: null,
  },
  {
    crop: 'PALMA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'PANICO',
    key: 1489,
    label: 'Panico',
    note: null,
  },
  {
    crop: 'PASCOLI',
    key: 1864,
    label: 'Prato pascolo',
    note: null,
  },
  {
    crop: 'PASTINACA',
    key: 1682,
    label: 'Pastinaca',
    note: null,
  },
  {
    crop: 'PATATA',
    key: 1840,
    label: 'Patata',
    note: null,
  },
  {
    crop: 'PATATA DOLCE',
    key: 1509,
    label: 'Patata Americana (Batata)',
    note: null,
  },
  {
    crop: 'PATATE NOVELLE',
    key: 1840,
    label: 'Patata',
    note: null,
  },
  {
    crop: 'PATATE TARDIVE',
    key: 1840,
    label: 'Patata',
    note: null,
  },
  {
    crop: 'PEPERONE',
    key: 1875,
    label: 'Peperone',
    note: null,
  },
  {
    crop: 'PEPINO (MELONE A PERA)',
    key: 1526,
    label: 'Melone',
    note: 'riguarda',
  },
  {
    crop: 'PERO',
    key: 1552,
    label: 'Pero',
    note: null,
  },
  {
    crop: 'PESCO (NETTARINE E PERCOCHE)',
    key: 1856,
    label: 'Pesco Nettarina',
    note: null,
  },
  {
    crop: 'PESCO (NETTARINE E PERCOCHE)',
    key: 1855,
    label: 'Pesco',
    note: null,
  },
  {
    crop: 'PETUNIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'PIANTE ARBOREE',
    key: 1759,
    label: 'Arboricoltura',
    note: 'guarda',
  },
  {
    crop: 'PIANTE ARBUSTIVE',
    key: 'nd',
    label: 'nd',
    note: 'guarda',
  },
  {
    crop: 'PIANTE INDUSTRIALI',
    key: 'nd',
    label: 'nd',
    note: 'guarda',
  },
  {
    crop: 'PINO SPP.',
    key: 1568,
    label: 'Pino',
    note: null,
  },
  {
    crop: 'PIOPPO',
    key: 1500,
    label: 'Pioppo',
    note: null,
  },
  {
    crop: 'PISELLI CON BACCELLO',
    key: 1462,
    label: 'Pisello',
    note: null,
  },
  {
    crop: 'PISELLO',
    key: 1462,
    label: 'Pisello',
    note: null,
  },
  {
    crop: 'PISELLO MANGIATUTTO (TACCOLA)',
    key: 1462,
    label: 'Pisello',
    note: null,
  },
  {
    crop: 'PISTACCHIO',
    key: 1756,
    label: 'Pistacchio',
    note: null,
  },
  {
    crop: 'PITTOSPORO',
    key: 1479,
    label: 'Pittosporo',
    note: null,
  },
  {
    crop: 'PLATANO',
    key: 1553,
    label: 'Platano',
    note: null,
  },
  {
    crop: 'POINSETTIA',
    key: 1521,
    label: 'Poinsettia (Stella Di Natale)',
    note: null,
  },
  {
    crop: 'POMACEE',
    key: 1481,
    label: 'Melo',
    note: 'e altre pomacee?  melo',
  },
  {
    crop: 'POMELO',
    key: 1708,
    label: 'Agrumi',
    note: null,
  },
  {
    crop: 'POMODORO',
    key: 1528,
    label: 'Pomodoro',
    note: null,
  },
  {
    crop: 'POMPELMO',
    key: 1565,
    label: 'Pompelmo',
    note: 'e Agrumi?',
  },
  {
    crop: 'PORRO',
    key: 1529,
    label: 'Porro',
    note: null,
  },
  {
    crop: 'PORTULACA',
    key: 1765,
    label: 'Portulaca O Porcellana Comune',
    note: null,
  },
  {
    crop: 'POTOS',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'PRATI',
    key: 1639,
    label: 'Prato Polifita',
    note: 'e altri prati',
  },
  {
    crop: 'PRATI E PASCOLI',
    key: 1864,
    label: 'Prato Pascolo',
    note: 'e Pascoli vari',
  },
  {
    crop: 'PREZZEMOLO',
    key: 1876,
    label: 'Prezzemolo',
    note: null,
  },
  {
    crop: 'PREZZEMOLO A GROSSA RADICE',
    key: 1876,
    label: 'Prezzemolo',
    note: null,
  },
  {
    crop: 'PRIMULA',
    key: 1772,
    label: 'Primula',
    note: null,
  },
  {
    crop: 'QUERCIA SPP.',
    key: 1618,
    label: 'Sughera Quercia Da Sughero',
    note: 'e Rovere?',
  },
  {
    crop: 'RABARBARO',
    key: 1863,
    label: 'Rabarbaro',
    note: null,
  },
  {
    crop: 'RADICCHIO',
    key: 1877,
    label: 'Radicchio',
    note: null,
  },
  {
    crop: 'RAFANO',
    key: 1707,
    label: 'Rafano',
    note: null,
  },
  {
    crop: 'RAPA',
    key: 1783,
    label: 'Mizuna O Brassica Rapa',
    note: null,
  },
  {
    crop: 'RAVANELLO',
    key: 1878,
    label: 'Ravanello',
    note: null,
  },
  {
    crop: 'RAVIZZONE (OLEAGINOSE)',
    key: 1493,
    label: 'Ravizzone',
    note: null,
  },
  {
    crop: 'RIBES A GRAPPOLI',
    key: 1742,
    label: 'Ribes Rosso',
    note: null,
  },
  {
    crop: 'RIBES NERO',
    key: 1739,
    label: 'Ribes Nero',
    note: null,
  },
  {
    crop: 'RIBES ROSSO',
    key: 1742,
    label: 'Ribes Rosso',
    note: null,
  },
  {
    crop: 'RISO',
    key: 1461,
    label: 'Risone',
    note: null,
  },
  {
    crop: 'RODODENDRO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ROSA',
    key: 1474,
    label: 'Rosa',
    note: null,
  },
  {
    crop: 'ROSACEE (ORNAMENTALI)',
    key: 1474,
    label: 'Rosa',
    note: 'e Rosa canina?',
  },
  {
    crop: 'ROSMARINO',
    key: 1894,
    label: 'Rosmarino',
    note: null,
  },
  {
    crop: 'ROVO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'RUCOLA',
    key: 1541,
    label: 'Rucola',
    note: null,
  },
  {
    crop: 'RUCOLA SELVATICA',
    key: 1541,
    label: 'Rucola',
    note: null,
  },
  {
    crop: 'RUTABAGA',
    key: 1510,
    label: 'Navoni Rutabaga',
    note: null,
  },
  {
    crop: 'SAINT PAULIA',
    key: 1775,
    label: 'Saintpaulia',
    note: null,
  },
  {
    crop: 'SALICE SPP.',
    key: 1828,
    label: 'Salice',
    note: null,
  },
  {
    crop: 'SALSEFRICA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'SALVIA',
    key: 1895,
    label: 'Salvia',
    note: null,
  },
  {
    crop: 'SANSEVIERIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'SANTOREGGIA',
    key: 1695,
    label: 'Santoreggia Montana',
    note: null,
  },
  {
    crop: 'SCAGLIOLA',
    key: 1835,
    label: 'Scagliola',
    note: null,
  },
  {
    crop: 'SCALOGNO',
    key: 1836,
    label: 'Scalogno',
    note: null,
  },
  {
    crop: 'SCAROLA',
    key: 1539,
    label: 'Indivia O Scarola',
    note: null,
  },
  {
    crop: 'SCORZONERA',
    key: 1696,
    label: 'Scorzonera',
    note: null,
  },
  {
    crop: 'SEDANO',
    key: 1530,
    label: 'Sedano',
    note: null,
  },
  {
    crop: 'SEDANO RAPA',
    key: 1887,
    label: 'Sedano Rapa',
    note: null,
  },
  {
    crop: 'SEGALE',
    key: 1837,
    label: 'Segala',
    note: null,
  },
  {
    crop: 'SENAPE',
    key: 1502,
    label: 'Senape',
    note: null,
  },
  {
    crop: 'SENAPE NERA',
    key: 1712,
    label: 'Senape Nera',
    note: null,
  },
  {
    crop: 'SESAMO',
    key: 1531,
    label: 'Sesamo',
    note: null,
  },
  {
    crop: 'SISARO (SCHERVOLA)',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'SOIA',
    key: 1450,
    label: 'Soia',
    note: null,
  },
  {
    crop: 'SOLANACEE',
    key: 1528,
    label: 'Pomodoro',
    note: 'pomodoro patata melanzana peperone?',
  },
  {
    crop: 'SOLANACEE',
    key: 1840,
    label: 'Patata',
    note: null,
  },
  {
    crop: 'SOLANACEE',
    key: 1525,
    label: 'Melanzana',
    note: null,
  },
  {
    crop: 'SOLANACEE',
    key: 1875,
    label: 'Peperone',
    note: null,
  },
  {
    crop: 'SOLIDAGO',
    key: 1700,
    label: "Verga D'Oro (Solidago Virga Aurea L.)",
    note: null,
  },
  {
    crop: 'SORGO',
    key: 1839,
    label: 'Sorgo',
    note: null,
  },
  {
    crop: 'SPELTA',
    key: 1482,
    label: 'Spelta',
    note: null,
  },
  {
    crop: 'SPINACI E SIMILI',
    key: 1879,
    label: 'Spinacio',
    note: null,
  },
  {
    crop: 'SPINACIO',
    key: 1879,
    label: 'Spinacio',
    note: null,
  },
  {
    crop: 'STERLIZIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'SULLA',
    key: 1859,
    label: 'Sulla',
    note: null,
  },
  {
    crop: 'SUSINO',
    key: 1833,
    label: 'Susino',
    note: null,
  },
  {
    crop: 'TABACCO',
    key: 1466,
    label: 'Tabacco',
    note: null,
  },
  {
    crop: 'TANGELO',
    key: 1566,
    label: 'Tangelo Mapo',
    note: null,
  },
  {
    crop: 'TANGERINO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'TIMO',
    key: 1884,
    label: 'Timo',
    note: null,
  },
  {
    crop: 'TOPINAMBUR',
    key: 1507,
    label: 'Topinambur',
    note: null,
  },
  {
    crop: 'TRIFOGLIO',
    key: 1533,
    label: 'Trifoglio',
    note: null,
  },
  {
    crop: 'TRIFOGLIO ALESSANDRINO',
    key: 1666,
    label: 'Trifoglio (Sp. Trifolium Alexandrinum L.)',
    note: null,
  },
  {
    crop: 'TRIFOGLIO INCARNATO',
    key: 1670,
    label: 'Trifoglio (Sp. Trifolium Incarnatum L.)',
    note: null,
  },
  {
    crop: 'TRIFOGLIO LADINO',
    key: 1672,
    label: 'Trifoglio (Sp. Trifolium Repens L.)',
    note: null,
  },
  {
    crop: 'TRIFOGLIO VIOLETTO',
    key: 1671,
    label: 'Trifoglio  (Sp. Trifolium Pratense L.)',
    note: null,
  },
  {
    crop: 'TRITICALE',
    key: 1512,
    label: 'Triticale',
    note: null,
  },
  {
    crop: 'TUBEROSA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'TULIPANO',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'UVA SPINA',
    key: 1741,
    label: 'Ribes Bianco (Uva Spina)',
    note: null,
  },
  {
    crop: 'VALERIANELLA (SONGINO O VALERIANA)',
    key: 1542,
    label: 'Dolcetta (Gallinella',
    note: 'Soncino',
  },
  {
    crop: 'VITE',
    key: 1692,
    label: 'Vite',
    note: null,
  },
  {
    crop: 'VITE DA TAVOLA',
    key: 1692,
    label: 'Vite',
    note: null,
  },
  {
    crop: 'VITE DA VINO',
    key: 1692,
    label: 'Vite',
    note: null,
  },
  {
    crop: 'WITLOOF',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ZINNIA',
    key: 'nd',
    label: 'nd',
    note: null,
  },
  {
    crop: 'ZUCCA',
    key: 1880,
    label: 'Zucca',
    note: null,
  },
  {
    crop: 'ZUCCHINO',
    key: 1881,
    label: 'Zucchino',
    note: null,
  },
];
